<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
html,body{
  margin: 0;
  height: 100%;
  width: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom left, #66d0a3 , #6aa6b1);

}
a{
  text-decoration: none;
  color: white;
  -webkit-tap-highlight-color: transparent;
}
</style>



// WEBPACK FOOTER //
// App.vue?664ca2ee